export default __webpack_public_path__ + "static/media/logo-github.45de0d2f.svg";